import React from 'react';
import { Upload, Button } from 'antd';
import { AddItemFormData } from './types';

const { Dragger } = Upload;

interface SkillUploadProps {
  styles: { [key: string]: string };
  formData: AddItemFormData;
  setFormData: React.Dispatch<React.SetStateAction<AddItemFormData>>;
  uploadProps: any;
}

const SkillUpload: React.FC<SkillUploadProps> = ({
  styles, formData, setFormData, uploadProps
}) => (
  <div className={styles.stepContainer}>
    <h2 className={styles.stepTitle}>Upload Files</h2>

    <div className={styles.uploadSection}>
      <div className={styles.uploadSubsection}>
        <p className={styles.uploadLabel}>Thumbnail</p>
        <ul className={styles.uploadRequirements}>
          <li>Upload a thumbnail image for your skill. Supported file types: PNG, Max Size: 5MB.</li>
          <li>Image should not contain any background (transparent BG).</li>
          <li>1024*1024 MAX.</li>
          <li>Images have to maintain 1:1 aspect ratio.</li>
        </ul>
        <Dragger {...uploadProps} className={styles.uploadArea}>
          <div className={styles.uploadContent}>
            <p className={styles.uploadText}>Drag and drop Your Images here, or</p>
            <Button type="link" className={styles.browseButton}>Browse Files</Button>
          </div>
        </Dragger>

        {formData.thumbnail && formData.thumbnail.length > 0 && (
          <div className={styles.uploadedFiles}>
            <h4>Uploaded File:</h4>
            {formData.thumbnail.map((file: any, index: number) => (
              <div key={index} className={styles.uploadedFile}>
                <div className={styles.filePreview}>
                  {file.type?.startsWith('image/') ? (
                    <img
                      src={URL.createObjectURL(file)}
                      alt={file.name}
                      className={styles.previewImage}
                    />
                  ) : (
                    <div className={styles.fileIcon}>📄</div>
                  )}
                </div>
                <div className={styles.fileInfo}>
                  <p title={file.name} className={styles.fileName}>{file.name}</p>
                  <p className={styles.fileSize}>
                    {(file.size / 1024 / 1024).toFixed(2)} MB
                  </p>
                </div>
                <button
                  type="button"
                  className={styles.removeBtn}
                  onClick={() => {
                    setFormData(prev => ({
                      ...prev,
                      thumbnail: []
                    }));
                  }}
                >
                  ✕
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  </div>
);

export default SkillUpload;
